import { gql } from '@apollo/client';

export const GetMyAmcrAccountQueryName = 'GetMyAmcrAccount';

export const GET_MY_AMCR_ACCOUNT_QUERY = gql`
  query ${GetMyAmcrAccountQueryName} {
    getMyAmcrAccount {
      username
      personId
      personName
      finderNames
      expiresAt
      expired
      findsUrl
    }
  }
`;
